'use strict';

var React = require('react');

var SvgPaintBrushMajor = function SvgPaintBrushMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.677 4.737a.25.25 0 0 0-.354 0l-2.836 2.836a.25.25 0 0 0 0 .354l3.586 3.585a.25.25 0 0 0 .353.001l2.837-2.836a.25.25 0 0 0 0-.354l-1.763-1.762-.47.47a.75.75 0 0 1-1.06-1.061l.47-.47-.763-.763Zm-1.414-1.06-4.586 4.585a1.75 1.75 0 0 0 0 2.475l.262.263-1.97 1.97a2.164 2.164 0 0 0 3.061 3.06l1.97-1.97.263.263a1.75 1.75 0 0 0 2.474 0l4.586-4.586a1.75 1.75 0 0 0 0-2.475l-3.586-3.585a1.75 1.75 0 0 0-2.474 0Zm-3.526 5.646.526-.525c.049.066.104.13.164.19l3.586 3.585c.06.06.123.115.189.164l-.525.525a.25.25 0 0 1-.354 0l-3.586-3.585a.25.25 0 0 1 0-.354Zm.263 2.737-1.97 1.97a.664.664 0 1 0 .94.94l1.97-1.97-.94-.94Z"
  }));
};
SvgPaintBrushMajor.displayName = "PaintBrushMajor";

exports.SvgPaintBrushMajor = SvgPaintBrushMajor;
